import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const Sizetable = props => (
    <p className="sizetable">*Sismic kit sizes are quite small, make sure to <OutboundLink href="/sismic_sizetable.pdf" target="_blank">check out our size guide</OutboundLink>!</p>
)

export default Sizetable




// WEBPACK FOOTER //
// ./src/components/Sizetable.js